import React from 'react';
import Anime from 'react-anime';
import './PipesThree.scss';
export default ({ isActive }) => {

  const animateBall = {
    translateY: [
      { value: '100vh', duration: 2000, easing: 'linear' }
    ],
  }
  const message = 'Over the past two decades, Novartis has collected 2 million patient-years of data from our clinical trials.';
  return (
    <div className="pipes--three">
      <div className="animation">
        <div className="bg-pipe-three">
          <div className="cap"></div>
        </div>
        <div className="pipe">
          <div className="tube">
            {isActive && (
              <Anime {...animateBall} className="inner-ball"></Anime>
            )}
          </div>
        </div>
      </div>
      <div className="text secondary-large pipes-three-text">
        <p>{message}</p>
      </div>
    </div>
  );
};